import React from 'react';
import PropTypes from 'prop-types';
import { Pattern } from 'utilities/components/pattern/component/view';

export const PatternOuterView = ({ data, color, isReverse }) => (
    <Pattern data={ data } color={ color } isReverse={ isReverse } />
);

PatternOuterView.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object]).isRequired,
    color: PropTypes.string,
    isReverse: PropTypes.bool
};

PatternOuterView.defaultProps = {
    color: ' #4a548c',
    isReverse: false
};